//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";

export default {
    name: "BowSticky",
    props: {
        htmlTag: {
            default: null,
            type: String,
        },
        position: {
            default: "absolute",
            type: String,
        },
        target: {
            default: null,
            type: [String, Object],
        },
        x: {
            default: "left-0",
            type: String,
        },
        y: {
            default: "top-0",
            type: String,
        },
    },
    data: () => ({
        initialPosition: {
            top: 0,
            bottom: 0,
        },
        height: 0,

        header: null,
        headerHeight: 0,

        parent: null,
        parentHeight: 0,

        translateValue: "translateY(0px)",

        scrollContent: null,
    }),
    computed: {
        ...mapState({
            bounding: ({ scroll }) => scroll.bounding,
            scroll: ({ scroll }) => scroll.scroll,
            loadCounter: ({ scroll }) => scroll.loadCounter,
            pageHeight: ({ scroll }) => scroll.pageHeight,
        }),

        ...mapGetters([
            "scroll/getBounding",
            "scroll/GET_SCROLL",
            "scroll/getLoadCounter",
            "scroll/getPageHeight",
        ]),
    },

    // mounted() {
    //     const stickyElement = this.$el;
    // },

    methods: {
        // updateTransform( transform ) {
        //   this.translateValue = transform;
        // }
    },
};
